/**
 * @file Image Banner
 */

import { gsap } from 'gsap';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';

/**
 * Image Banner component.
 */
const vImageBanner = () => {
	const imageBanner = document.querySelector('.m-image-banner__animation');

	if (!imageBanner) {
		return;
	}

	gsap.registerPlugin(MorphSVGPlugin);
	const tl = gsap.timeline({
		repeat: -1,
		repeatDelay: 1,
		defaults: {
			ease: 'power3.inOut',
			duration: 1,
		},
	});

	tl
	.addLabel('phone')
	.to('#phone_icon1', {
		morphSVG: '#phone_icon2',
		opacity: 1,
	}, 'phone')
	.to('#phone_box1', {
		morphSVG: '#phone_box1',
		opacity: .4
	}, 'phone+=.2')
	.to('#phone_box1', {
		morphSVG: '#phone_box2',
		opacity: .4
	}, 'phone+=1.2')
	.to('#phone_box1', {
		morphSVG: '#phone_box2',
		opacity: 0
	}, 'phone+=2.2')
	.to('#phone_icon1', {
		morphSVG: '#phone_icon1',
		opacity: 1
	}, 'phone+=2.2')
	.addLabel('computer')
	.to('#computer_icon1', {
		morphSVG: '#computer_icon2',
		opacity: 1
	}, 'computer')
	.to('#computer_box_a1', {
		morphSVG: '#computer_box_a1',
		opacity: .4
	}, 'computer+=.5')
	.to('#computer_box_a1', {
		morphSVG: '#computer_box_a2',
		opacity: .4,
		duration: .5,
	}, 'computer+=1')
	.to('#computer_box_a1', {
		morphSVG: '#computer_box_a2',
		opacity: 0,
		duration: 1.5,
	}, 'computer+=2')
	.to('#computer_icon1', {
		morphSVG: '#computer_icon1',
		opacity: 1
	}, 'computer+=2.5')
	.addLabel('microphone')
	.to('#mic_bottom_icon1', {
		morphSVG: '#mic_bottom_icon2',
		opacity: 1,
		duration: .7,
	}, 'microphone')
	.to('#mic_bottom_icon1', {
		morphSVG: {
			shape: '#mic_bottom_icon1',
			shapeIndex: 3,
		},
		opacity: 1,
		duration: .5,
	}, 'microphone+=2')
	.to('#mic_top_icon1', {
		morphSVG: '#mic_top_icon2',
		opacity: 1,
		duration: .5,
	}, 'microphone')
	.to('#mic_top_icon1', {
		morphSVG: '#mic_top_icon1',
		opacity: 1,
		duration: .5,
	}, 'microphone+=2')
	.to('#mic_signal', {
		morphSVG: '#mic_signal',
		opacity: .7,
		duration: .5,
	}, 'microphone+=0.9')
	.to('#mic_signal', {
		morphSVG: '#mic_signal',
		opacity: 0,
		duration: .5,
	}, 'microphone+=1.9')
	.addLabel('play')
	.to('#play_bottom_icon1', {
		morphSVG: '#play_bottom_icon2',
		fill: '#31d0e7',
		opacity: 1
	}, 'play')
	.to('#play_top_icon1', {
		morphSVG: '#play_top_icon2',
		opacity: 1,
	}, 'play')
	.to('#video_reel', {
		morphSVG: '#video_reel',
		opacity: 1,
	}, 'play')
	.to('#video_reel', {
		morphSVG: '#video_reel',
		opacity: 0,
	}, 'play+=2')
	.to('#play_bottom_icon1', {
		morphSVG: '#play_bottom_icon1',
		fill: '#31d0e7',
		opacity: 1,
	}, 'play+=2')
	.to('#play_top_icon1', {
		morphSVG: '#play_top_icon1',
		opacity: 1,
	}, 'play+=2')
	.addLabel('camera')
	.to('#camera_lense_1', {
		morphSVG: '#camera_lense_2',
		opacity: 1,
	}, 'camera')
	.to('#camera_body', {
		morphSVG: '#camera_body',
		opacity: 0,
	}, 'camera')
	.to('#camera_flaps', {
		morphSVG: '#camera_flaps',
		opacity: .5,
		duration: .8,
	}, 'camera+=0.2')
	.to('#camera_lense_1', {
		morphSVG: '#camera_lense_1',
		opacity: 1,
	}, 'camera+=2')
	.to('#camera_body', {
		morphSVG: '#camera_body',
		opacity: 1,
	}, 'camera+=2')
	.to('#camera_flaps', {
		morphSVG: '#camera_flaps',
		opacity: 0,
		duration: .6,
	}, 'camera+=2')
	.to('#camera_dude', {
		morphSVG: '#camera_dude',
		opacity: 0,
	}, 'camera+=2')
	.addLabel('social')
	.to('#social1', {
		morphSVG: '#social2',
		opacity: 1,
		duration: .6,
	}, 'social+=0.8')
	.to('#social1', {
		morphSVG: '#social6',
		opacity: 1,
		duration: .3,
	}, 'social+=1.6')
	.to('#social1', {
		morphSVG: '#social5',
		opacity: 1,
		duration: .3,
	}, 'social+=2.2')
	.to('#social1', {
		morphSVG: '#social4',
		opacity: 1,
		duration: .3,
	}, 'social+=2.8')
	.to('#social1', {
		morphSVG: '#social1',
		opacity: 1,
		duration: .3,
	}, 'social+=3.4')
	.addLabel('search')
	.to('#search_icon1', {
		morphSVG: '#search_icon2',
		opacity: 1,
	}, 'search+=0.5')
	.to('#search_icon1', {
		morphSVG: '#search_icon1',
		opacity: 1,
	}, 'search+=1.5')
	.to('#search_g', {
		morphSVG: '#search_g',
		opacity: 1,
	}, 'search+=0.5')
	.to('#search_g', {
		morphSVG: '#search_g',
		opacity: 0,
	}, 'search+=1.5');
};

export default vImageBanner;
